/* eslint-disable prefer-rest-params */
import config from './appconfig';
const isProduction = config.isProduction;

const isObject = (obj: object) =>
  Object.prototype.toString.call(obj) === '[object Object]';

const testSessionStorageAvailable = function () {
  let guard = true;
  try {
    guard = window ? true : false;
    guard = window.sessionStorage ? true : false;
    // @ts-expect-error guard is always true, but not in webview context
    guard = window.sessionStorage.getItem ? true : false;
  } catch {
    // we crash on ios / webview don't use LS
    console.error('crash without window / sessionStorage');
    guard = false;
  }
  return guard;
};

const isSessionStorageAvailable = testSessionStorageAvailable();

let isDebugMode = false;
if (isSessionStorageAvailable) {
  isDebugMode = window?.sessionStorage?.getItem('moindebug') === 'true';
}

const loggerFunctions = {
  log: window.console.log.bind(window.console, '\x1b[1mlog\x1b[0m: %s'),
  warn: window.console.warn.bind(window.console, '\x1b[33mwar\x1b[0m: %s'),
  error: window.console.error.bind(window.console, '\x1b[31merr\x1b[0m: %s'),
};

const logg = window.console.log.bind(window.console, '%s');
const logLine = function () {
  const level = arguments[0];
  let msg = '';
  for (let i = 1; i < arguments.length; i++) {
    const isObj = isObject(arguments[i]) || Array.isArray(arguments[i]);
    msg += ` ${isObj ? JSON.stringify(arguments[i]) : arguments[i]}`;
  }
  const now = new Date().toLocaleTimeString('de-de');
  const logMessage = `${now} | ${level} | ${msg}`;
  logg(logMessage);

};

if (!isDebugMode && isProduction) {
  loggerFunctions.log = () => { };
  loggerFunctions.warn = () => { };
  loggerFunctions.error = () => { };
}

if (isDebugMode) {

  loggerFunctions.log = logLine.bind(console.log);
  loggerFunctions.warn = logLine.bind(console.warn);
  loggerFunctions.error = logLine.bind(console.error);
}

loggerFunctions.log(
  'log',
  `logger isProduction: ${isProduction}, isDebugMode ${isDebugMode}`,
);

export default {...loggerFunctions,};
